<template>
  <section>
    <p><strong>{{ pickup.receiver ? pickup.receiver.organisation_name : '-' }}</strong></p>
    <p><strong>{{ pickup.receiver ? `${pickup.receiver.first_name || ''} ${pickup.receiver.last_name || ''}` : '' }}</strong></p>
    <p>{{ pickup.receiver ? `${pickup.receiver.address_line1 || ''} ${pickup.receiver.address_line2 || ''} ${pickup.receiver.locality || ''} ${pickup.receiver.administrative_area || ''} ${pickup.receiver.postal_code || ''} ${pickup.receiver.country || ''}` : '' }}</p>
    <p>
      <a
        v-if="pickup.receiver && pickup.receiver.phone"
        :href="`tel:${pickup.receiver.phone}`"
      >
        {{ pickup.receiver.phone }}
      </a>
    </p>
    <a
      v-if="pickup.receiver && pickup.receiver.email"
      :href="`mailto:${pickup.receiver.email}`"
    >
      {{ pickup.receiver.email }}
    </a>
  </section>
</template>

<script>
export default {
  props: {
    pickup: {
      type: Object,
      required: true
    }
  }
}
</script>
